import { useState } from "react";
import { Box, Typography, Alert } from "@mui/material";
import { formSurfaceSx } from "constants/pageSurfaces";
import Breadcrumbs from "components/common/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import useLocations from "hooks/locations/useLocations";
import EmployeeForm, { emptyEmployeeForm, EmployeeFormValues } from "./EmployeeForm";

export default function EmployeeNew() {
  const navigate = useNavigate();
  const { locations } = useLocations();
  const [values, setValues] = useState<EmployeeFormValues>(emptyEmployeeForm());
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const payload = {
      ...values,
      officeLocationId: values.officeLocationId.trim() || null,
      externalEmployeeId: values.externalEmployeeId.trim() || null,
      homeAddress: values.homeAddress.trim() || null,
      homeAddress2: values.homeAddress2.trim() || null,
      homeCity: values.homeCity.trim() || null,
      homeState: values.homeState.trim() || null,
      homeZipcode: values.homeZipcode.trim() || null,
      homeCountry: values.homeCountry.trim() || null,
    };
    api
      .post("/employees", { employee: payload })
      .then(() => navigate("/employees"))
      .catch((err) => {
        const msg =
          err?.response?.data?.errors?.join?.(", ") || "Could not create employee";
        setError(String(msg));
      });
  };

  return (
    <div>
      <Box>
        <Breadcrumbs
          data={[
            { label: 'Dashboard', to: '/dashboard' },
            { label: 'Employees', to: '/employees' },
            { label: 'New' },
          ]}
        />
      </Box>
      <Box sx={formSurfaceSx}>
        <Typography variant='h4' mb={2} fontWeight='bold'>
          New employee
        </Typography>
        {error ? (
          <Alert severity='error' sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <EmployeeForm
          values={values}
          onChange={setValues}
          onSubmit={handleSubmit}
          submitLabel='Create'
          cancelTo='/employees'
          locations={locations}
        />
      </Box>
    </div>
  );
}
